// Routes
import { authenticationRoutes } from './auth/endpoints';
import { syliusApiRoutes } from './sylius/endpoints';
const BASE_URL = window.location.href;
const API_BASE = 'api';
const ENDPOINTS = Object.assign(Object.assign({ API_BASE_URL: `${BASE_URL}/${API_BASE}`, BASE_URL }, syliusApiRoutes), authenticationRoutes);
export { API_BASE, BASE_URL, ENDPOINTS };
//# sourceMappingURL=global.js.map